import { Link } from "react-router-dom";
import SharedLayout from "../components/SharedLayout";
import useSEO from "../utils/useSEO";

const LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "About Us", to: "/about" },
  { label: "BerryChat CRM", to: "/crm" },
  { label: "SEO Services", to: "/seo-services" },
  { label: "AI Solutions", to: "/ai-services" },
  { label: "Contact Us", to: "/contact" },
];

export default function NotFoundPage() {
  useSEO({
    title: "Page Not Found | BerryByte Innovations",
    description: "The page you're looking for doesn't exist. Return to BerryByte Innovations to explore our software development services.",
    canonical: "https://www.berrybyteinn.com/404",
  });

  return (
    <SharedLayout>
      <div className="relative min-h-screen bg-[#050810] flex items-center justify-center px-6 py-32">
        <div className="absolute inset-0 opacity-[0.02]" style={{ backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)", backgroundSize: "80px 80px" }} />

        <div className="relative max-w-2xl mx-auto text-center">
          {/* 404 number */}
          <div className="text-[120px] sm:text-[160px] font-black leading-none bg-gradient-to-r from-violet-400 to-cyan-400 bg-clip-text text-transparent select-none mb-4">
            404
          </div>

          <h1 className="text-3xl sm:text-4xl font-black text-white mb-4">
            Page Not Found
          </h1>
          <p className="text-slate-400 text-lg mb-10 max-w-md mx-auto leading-relaxed">
            Sorry, the page you're looking for doesn't exist or has been moved. Let's get you back on track.
          </p>

          {/* Quick links */}
          <div className="mb-10">
            <p className="text-sm text-slate-500 mb-4 uppercase tracking-wider font-medium">Quick Links</p>
            <div className="flex flex-wrap gap-3 justify-center">
              {LINKS.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="px-4 py-2 rounded-xl border border-white/10 bg-white/[0.03] text-slate-400 hover:text-white hover:border-violet-500/50 hover:bg-violet-500/10 transition-all duration-200 text-sm font-medium"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* CTA */}
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl bg-gradient-to-r from-violet-600 to-cyan-600 text-white font-semibold hover:opacity-90 transition-opacity"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4">
              <path d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Homepage
          </Link>

          {/* Contact hint */}
          <p className="mt-8 text-slate-600 text-sm">
            Think something's broken?{" "}
            <Link to="/contact" className="text-violet-400 hover:text-violet-300 transition-colors">
              Let us know
            </Link>
          </p>
        </div>
      </div>
    </SharedLayout>
  );
}
